import React from 'react';
import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import OnOffMidiasEnviadas from '../ContentPlanoOnOff/MidiasEnviadas';
import './styles.scss';

const PlanoOnOffMidiasEnviadas = () => {
  return (
    <>
      <HeaderApp />
      <OnOffMidiasEnviadas />
      <Bottom />
    </>
  );
};

export default PlanoOnOffMidiasEnviadas;
